window.initCartUpsellSlider = function() {
  document.querySelectorAll('.cart-upsell-slider-d5').forEach(function(slider) {
    const wrapper = slider.querySelector('.cart-upsell-wrapper-d5');
    const prev = slider.querySelector('.cua-prev-d5');
    const next = slider.querySelector('.cua-next-d5');

    if (!wrapper || !prev || !next) return;

    prev.replaceWith(prev.cloneNode(true));
    next.replaceWith(next.cloneNode(true));

    const newPrev = slider.querySelector('.cua-prev-d5');
    const newNext = slider.querySelector('.cua-next-d5');

    function getScrollAmount() {
      const item = wrapper.querySelector('.product-cart-item');
      if (!item) return 200;
      return item.offsetWidth + parseInt(getComputedStyle(wrapper).gap || 0);
    }

    newPrev.addEventListener('click', function() {
      wrapper.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    newNext.addEventListener('click', function() {
      wrapper.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  });
};

